export default "__VITE_ASSET__32VkJviA7$UfR5MHZzmKSg__";